import {
  AbleToOperate,
  AbleToOperateProps,
} from 'pages/Asset/tabs/Cases/components/AbleToOperate/AbleToOperate';
import { SimpleAsset } from 'queries/assets/contract';
import { useTranslation } from 'react-i18next';
import { CasesAlarming, CopyIcon, ModelsAlarming } from 'components';
import './AssetField.scss';
import { EllipsisTextWithTooltip, TextButton } from '@shape-ds/components';
import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import { ASSET_PAGE } from 'config/paths';
import { findByAssetNameRecursive } from 'utils/Trail';
import { getTooltipText } from 'utils/EventUtil';
import { useAssetsByWorkspaceQuery } from 'queries/assets/queries';
import ExternalLink from 'components/ExternalLink/ExternalLink';
import { IS_DEMO } from 'config/constants';
import { useFeatureFlag } from '@shape/feature-flag';

interface AssetFieldProps {
  asset: SimpleAsset;
  ableToOperate?: AbleToOperateProps;
}

export const AssetField = ({ asset, ableToOperate }: AssetFieldProps) => {
  const { t } = useTranslation();
  const { data } = useAssetsByWorkspaceQuery();
  const assetName = asset?.name;
  const eventAssetTree =
    findByAssetNameRecursive(data?.items ?? [], asset.name)?.breadcrumbPath ?? [];

  const trailWithoutThisAsset = eventAssetTree.filter((i) => i.name !== asset.name);
  trailWithoutThisAsset.pop();
  const tooltipText = getTooltipText(trailWithoutThisAsset, asset.name);
  const is3DEnabled = useFeatureFlag('demo-show-3d-button');
  return (
    <div className="asset-field cases-tag">
      <div className="asset-field-name">
        <span className="asset-field-label">{t('case:common.asset')}:</span>
        <div className="asset-field-value">
          <TextButton
            onClick={() => {
              window.open(ASSET_PAGE(asset.id, 'monitoring'), '_blank');
            }}
            className="asset-field-button"
            endIcon={<LaunchOutlinedIcon />}
            color="inherit"
          >
            <EllipsisTextWithTooltip text={assetName} />
          </TextButton>
          <CopyIcon text={assetName} />
          {IS_DEMO && is3DEnabled && (
            <ExternalLink
              url={ASSET_PAGE(asset.id)}
              label="3D"
              isExternalLink
              iconPosition="end"
              themeColor="blue"
              tooltipText={tooltipText}
              className="external-link-container-link"
            />
          )}
        </div>
      </div>
      <div className="asset-field-status">
        {ableToOperate && <AbleToOperate {...ableToOperate} />}
        <ModelsAlarming asset={asset} />
        <CasesAlarming asset={asset} />
      </div>
    </div>
  );
};
